
import Cookies from "js-cookie";
import { Component, Prop, Vue } from "vue-property-decorator";
import Cookie from "../../utils/cookie";
@Component
export default class Header extends Vue {
  private fNavigation: string = ""
  private activeShow: boolean = false
  private activeShow1: boolean = false
  @Prop({
    type: Object,
    default: {},
    required: true,
  })
  headData!: any;
  
  created() {
    // console.log(this.headData, Cookie.get("wqtoken"));
    this.getNavigation()
    this.navActive()
  }
  async getNavigation() {
    let params = {
      m: String(this.$route.query.m),
    };
    console.log(params);
    let Res = await this.$http.personalCenter.Navigation(params);
    console.log("Res", Res)
    this.fNavigation = Res.Items
  }
  async navActive(){
      if (this.$route.path == '/personalCenter') {
          this.activeShow = true
      }else{
          this.activeShow = false
      }
      if (this.$route.path == '/my') {
          this.activeShow1 = true
      }else{
          this.activeShow1 = false
      }
  }
  async personCenter() {
    this.$router.push({
        path: '/personalCenter',
        query: this.$route.query,
    })
  }
  async my(){
      this.$router.push({
        path: '/my',
        query: this.$route.query,
      })
  }
  async outLogin(){
      this.$confirm('确认退出么?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        localStorage.clear()
        localStorage.removeItem('wqToken')
        Cookies.remove('wqToken')
        this.$router.push({
          path: '/login',
          query: this.$route.query,
        })
      }).catch(() => {         
      });
    }
}
